import { MouseEvent } from 'react';

export enum BaseButtonColor {
    orange = 'orange',
    gray = 'gray',
}

export interface BaseButtonProps {
    onClick: (event: MouseEvent<HTMLButtonElement>) => void;
    isAnimated?: boolean;
    animationDuration?: number;
    className?: string;
    color?: BaseButtonColor;
    withIcon?: boolean;
}
